var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    class: [_vm.marginTopClass, _vm.marginBottomClass],
    staticStyle: {
      "min-width": "370px"
    }
  }, [_c('div', {
    staticClass: "container-fluid p-0 social-media-container"
  }, [_c('div', {
    staticClass: "container pb-0 px-3 px-lg-0 px-xl-0 d-flex flex-row",
    class: _vm.layoutClass
  }, [_vm.isSocialMediaSiblingsVisible ? _c('div', {
    staticClass: "w-100 row m-0 py-3 d-flex flex-row justify-content-between align-items-center"
  }, [_vm._t("default"), _c('div', {
    staticClass: "col-lg-3 col-xl-3 p-0 mt-2 mt-lg-0 mt-xl-0",
    class: _vm.socialShareColumnClass
  }, [_c('SocialShareBookmark', {
    staticClass: "m-0 p-0",
    class: _vm.socialShareFlexJustifyClass,
    attrs: {
      "id": "social-share",
      "title": _vm.title,
      "description": _vm.description,
      "type": _vm.type
    }
  })], 1)], 2) : _c('div', {
    staticClass: "py-3"
  }, [_c('SocialShareBookmark', {
    staticClass: "justify-content-center justify-content-md-start",
    attrs: {
      "id": "social-share",
      "title": _vm.title,
      "description": _vm.description,
      "type": _vm.type
    }
  })], 1)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }